import React, { useRef, useState, useEffect } from 'react'
import Button from 'components/Base/Button'
import SwiperCore, { Mousewheel } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import classnames from 'classnames'
import * as styles from './index.module.less'

interface SolutionsSwiperProps {
  className?: string
  caseMenuList?: string[]
  dataSource?: any[]
  /**是否含有tab */
  hasTab?: boolean
}

const SolutionsSwiper: React.FC<SolutionsSwiperProps> = ({ className, caseMenuList, dataSource, hasTab = true }) => {
  const mySwiper = useRef<SwiperCore>(null)
  const [active, setActive] = useState<number>(0)
  useEffect(() => {
    mySwiper.current && mySwiper.current.slideTo(active)
  }, [active])
  return (
    <div className={classnames(styles.container, 'lg:w-[1200px] lg:mx-auto px-[20px] lg:px-auto ', className)}>
      <div className="lg:w-[1000px] mx-auto mt-[20px] lg:mt-[38px]">
        {hasTab && (
          <ul className="flex text-center">
            {caseMenuList?.map((item, index) => {
              return (
                <li
                  className={classnames(
                    'flex-1 py-[6px] lg:py-[12px] text-[14px] lg:text-[18px] text-[#181818]  border-b-[1px] border-[#D2D7DF] cursor-pointer',
                    { 'solutions-case-active': active === index },
                  )}
                  key={index + item}
                  onClick={() => {
                    setActive(index)
                  }}
                >
                  {item}
                </li>
              )
            })}
          </ul>
        )}
        <div className="lg:mt-[60px] mt-[20px] lg:h-[332px] shadow-[0px_2px_10px_0px_rgba(193,208,211,0.42)] rounded-[4px] overflow-hidden">
          <Swiper
            autoplay={false}
            allowTouchMove={false}
            className="h-full bg-[#fff]"
            onSwiper={(swiper) => (mySwiper.current = swiper)}
          >
            {dataSource?.map((item, index) => {
              return (
                <SwiperSlide key={index} className={styles.swiperSlide}>
                  <a href={item?.btn_link} target="_blank" className="w-full h-full block lg:flex">
                    <div className="lg:w-[588px] lg:h-full">
                      <img
                        className="h-full w-full"
                        src={item?.img_url?.publicURL || item?.img_url}
                        alt={item?.title}
                      />
                    </div>
                    <div className="py-[18px] px-[14px] lg:flex-1 lg:py-[80px] lg:px-[30px] bg-[#fff]">
                      <h3 className="line-clamp-2 text-[16px] lg:text-[18px] text-[#1f2d3d] leading-[24px] font-medium">
                        {item?.title}
                      </h3>
                      <p
                        className={classnames(
                          'mt-[10px] lg:mt-[12px] text-[14px] text-[#475669] leading-[24px]',
                          'line-clamp-3',
                        )}
                      >
                        {item?.desc}
                      </p>
                      <p className="mt-[30px] lg:mt-[36px]">
                        <Button
                          className="text-[12px] lg:text-[14px]  text-[#04cb94] text-left"
                          btnType="text"
                          href={item?.btn_link}
                        >
                          {item?.btn_text}
                        </Button>
                        <span className="inline-block arrows-icon"></span>
                      </p>
                    </div>
                  </a>
                </SwiperSlide>
              )
            })}
          </Swiper>
        </div>
      </div>
    </div>
  )
}

export default SolutionsSwiper
